(() => {
  const setup = header => {
    if (header.dataset.megaReady) return;
    header.dataset.megaReady = 'true';
    const menus = [...header.querySelectorAll('[data-cft-mega]')];
    const abort = new AbortController();
    const events = { signal: abort.signal };
    const close = (menu, focus = false) => {
      menu.open = false;
      menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      if (focus) menu.querySelector('summary').focus();
    };
    menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      summary.setAttribute('aria-expanded', String(menu.open));
      menu.querySelectorAll('[data-cft-menu-fallback]').forEach(link => { link.hidden = true; });
      const categories = [...menu.querySelectorAll('[data-cft-menu-category]')];
      const panels = [...menu.querySelectorAll('[data-cft-menu-panel]')];
      categories.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          categories.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          panels.forEach(panel => { panel.hidden = panel.dataset.cftMenuPanel !== button.dataset.cftMenuCategory; });
          const results = menu.querySelector('.cft-mega-results');
          if (results) results.scrollTop = 0;
        }, events);
      });
      menu.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(menu.open));
        if (!menu.open) return;
        menus.filter(other => other !== menu).forEach(other => close(other));
        header.querySelectorAll('[data-cft-submenu][open]').forEach(other => {
          other.open = false;
          other.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        });
        const search = header.querySelector('[data-search-panel]');
        if (search && !search.hidden) {
          search.querySelector('[data-search-close]')?.click();
          summary.focus();
        }
      }, events);
    });
    header.querySelector('[data-search-open]')?.addEventListener('click', () => menus.forEach(menu => close(menu)), events);
    header.querySelectorAll('[data-cft-submenu]').forEach(other => other.addEventListener('toggle', () => {
      if (other.open) menus.forEach(menu => close(menu));
    }, events));
    const mobile = header.querySelector('.cft-mobile-menu');
    mobile?.addEventListener('toggle', () => {
      if (!mobile.open) menus.filter(menu => mobile.contains(menu)).forEach(menu => close(menu));
    }, events);
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const menu = menus.find(item => item.open);
      if (menu) { event.preventDefault(); event.stopImmediatePropagation(); close(menu, true); }
    }, { ...events, capture: true });
    document.addEventListener('click', event => {
      menus.forEach(menu => { if (menu.open && !menu.contains(event.target)) close(menu); });
    }, events);
    window.matchMedia('(min-width:1081px)').addEventListener('change', () => menus.forEach(menu => close(menu)), events);
    header._cftMegaDisconnect = () => { abort.abort(); delete header.dataset.megaReady; };
  };
  const scan = root => {
    if (root.matches?.('[data-search-header]')) setup(root);
    root.querySelectorAll('[data-search-header]').forEach(setup);
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-search-header]')) event.target._cftMegaDisconnect?.();
    event.target.querySelectorAll('[data-search-header]').forEach(header => header._cftMegaDisconnect?.());
  });
})();
